import { render } from "./orderSuccessModal.vue?vue&type=template&id=20a25a13&scoped=true"
import script from "./orderSuccessModal.vue?vue&type=script&lang=js"
export * from "./orderSuccessModal.vue?vue&type=script&lang=js"

import "./orderSuccessModal.vue?vue&type=style&index=0&id=20a25a13&lang=scss&scoped=true"

import exportComponent from "D:\\web-master\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a25a13"]])

export default __exports__